import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import toastr from '../../toastr';
import AutoSuggest from 'react-autosuggest';

import { createMultiContractRelationAction,
  searchBenefitSponsorContractRelations } from '../actions';

class MultiContractOrgRelationsCreateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formTriggered:         false,
      primaryOrgNameValue:   '',
      secondaryOrgNameValue: ''
    };
    this.initialFormValues = {
      priBscorId: '',
      secBscorId: ''
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isCreating && !this.props.isCreating) {
      if (_.isEmpty(this.props.errors)) {
        this.triggerCreateForm();
      } else {
        toastr.error(this.props.errors);
      }
    }
  }

  onPrimarySuggestionsFetchRequested = ({ value }) => {
    if (_.get(value, 'length') > 2) {
      this.props.searchBenefitSponsorContractRelations({
        organizationName: value,
        orgSide:          'primaryOrganizationSuggestions'
      });
    }
  }

  onPrimaryOrgNameChange = (event, { newValue }) => {
    const match = this.props.primaryOrganizationSuggestions.filter(mcor => mcor.organization.name === newValue);
    this.setState({
      primaryOrgNameValue: newValue,
      priBscorId: _.get(match, 'id')
    });
  };

  onPrimarySuggestionSelected = (event, { suggestion }) => {
    event.preventDefault();
    this.setState({ priBscorId: suggestion.id });
  };

  onSecondarySuggestionsFetchRequested = ({ value }) => {
    if (_.get(value, 'length') > 2) {
      this.props.searchBenefitSponsorContractRelations({
        organizationName: value,
        orgSide:          'secondaryOrganizationSuggestions'
      });
    }
  }

  onSecondaryOrgNameChange = (event, { newValue }) => {
    const match = this.props.secondaryOrganizationSuggestions.filter(mcor => mcor.organization.name === newValue);
    this.setState({
      secondaryOrgNameValue: newValue,
      secBscorId: _.get(match, 'id')
    });
  };

  onSecondarySuggestionSelected = (event, { suggestion }) => {
    event.preventDefault();
    this.setState({ secBscorId: suggestion.id });
  };

  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : languages.filter(lang =>
      lang.name.toLowerCase().slice(0, inputLength) === inputValue
    );
  };

  getSuggestionValue = suggestion => suggestion.organization.name;

  notifyError = msg => toastr.error(_.truncate(msg, { length: 300 }), null, {
    timeOut:         0,
    extendedTimeOut: 0,
    closeButton:     true,
    tapToDismiss:    false
  });

  triggerCreateForm() {
    this.setState({ formTriggered: !this.state.formTriggered });
  }

  newMultiContract() {
    const args = {
      priBscorId: this.state.priBscorId,
      secBscorId: this.state.secBscorId
    };

    this.props.createMultiContractRelationAction(args);
  }

  generateCreateForm() {
    this.primarySuggestionInputProps = {
      placeholder: 'Primary organization name',
      value:       this.state.primaryOrgNameValue,
      onChange:    this.onPrimaryOrgNameChange
    };

    this.secondarySuggestionInputProps = {
      placeholder: 'Secondary organization name',
      value:       this.state.secondaryOrgNameValue,
      onChange:    this.onSecondaryOrgNameChange
    };

    const idsPresent = this.state.priBscorId && this.state.secBscorId;

    return (
      <div>
        {this.state.formTriggered &&
          <React.Fragment>
            <Formik
              initialValues={this.initialFormValues}
              onSubmit={(values, actions) => this.newMultiContract(values, actions)}
              validateOnBlur={false}
              validateOnChange={false}
            >
              {() => (
                <div>
                  <h2>Create Multi Contract</h2>
                  <Form>
                    <div className="multi_contract_create_fields">
                      <div className="label_container">
                        <label htmlFor="priBscorId">Primary Organization</label>
                      </div>
                      <div className="field_container">
                        <AutoSuggest
                          className="multi_contract_input"
                          name="priBscor"
                          suggestions={this.props.primaryOrganizationSuggestions || []}
                          onSuggestionsFetchRequested={this.onPrimarySuggestionsFetchRequested}
                          onSuggestionsClearRequested={_.noop}
                          getSuggestionValue={this.getSuggestionValue}
                          renderSuggestion={this.renderSuggestion}
                          onSuggestionSelected={this.onPrimarySuggestionSelected}
                          inputProps={this.primarySuggestionInputProps}
                        />
                      </div>
                      <div className="label_container">
                        <label htmlFor="secBscorId">Secondary Organization</label>
                      </div>
                      <div className="field_container">
                        <AutoSuggest
                          name="secBscor"
                          suggestions={this.props.secondaryOrganizationSuggestions || []}
                          onSuggestionsFetchRequested={this.onSecondarySuggestionsFetchRequested}
                          onSuggestionsClearRequested={_.noop}
                          getSuggestionValue={this.getSuggestionValue}
                          renderSuggestion={this.renderSuggestion}
                          onSuggestionSelected={this.onSecondarySuggestionSelected}
                          inputProps={this.secondarySuggestionInputProps}
                        />
                      </div>
                    </div>
                    <div className="button_container">
                      <button
                        className="button"
                        type="submit"
                        disabled={this.props.isCreating || !idsPresent }
                      >
                        {this.props.isCreating ? 'Submitting ...' : 'Submit'}
                      </button>
                      <button
                        className="button secondary"
                        type="button"
                        onClick={() => this.triggerCreateForm()}
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                </div>
              )}
            </Formik>
          </React.Fragment>}
      </div>
    );
  }

  renderSuggestion = suggestion => (
    <div>
      {suggestion.organization.name}
    </div>
  );

  render() {
    return (
      <div className="multi_contract_create">
        {this.props.hasBillingAccess && !this.state.formTriggered  &&
          <button
            className="button multi_contract_create_button"
            onClick={() => this.triggerCreateForm()} type="button"
          >
            New Multi Contract
          </button>
        }
        {this.generateCreateForm()}
      </div>
    );
  }
}

MultiContractOrgRelationsCreateForm.propTypes = {
  createMultiContractRelationAction:     PropTypes.func,
  searchBenefitSponsorContractRelations: PropTypes.func,
  isCreating:                            PropTypes.bool,
  errors:                                PropTypes.array,
  primaryOrganizationSuggestions:        PropTypes.array,
  secondaryOrganizationSuggestions:      PropTypes.array,
  hasBillingAccess:                      PropTypes.bool,
  multiContractOrgRelations:             PropTypes.array
};

const mapStateToProps = state => ({
  isCreating:                       state.mcorReducer.isCreating,
  errors:                           state.mcorReducer.errors,
  primaryOrganizationSuggestions:   state.mcorReducer.primaryOrganizationSuggestions || [],
  secondaryOrganizationSuggestions: state.mcorReducer.secondaryOrganizationSuggestions || []
});

const mapDispatchToProps
  = { createMultiContractRelationAction, searchBenefitSponsorContractRelations };

export default connect(mapStateToProps, mapDispatchToProps)(MultiContractOrgRelationsCreateForm);
